import { defineAsyncComponent } from 'vue'

import { PILLAR_ID } from '@/models/pillars'

export const hiddenPillars = [PILLAR_ID.CLINICAL_RECORD]

export const perfil = {
  id: PILLAR_ID.PROFILE,
  title: 'Perfil',
  componentName: 'PProfile', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillar-profile" */
        '@/pillars/profile/PProfile.vue'
      )
  )
}

export const historico = {
  id: PILLAR_ID.CLINICAL_PROFILE,
  title: 'Histórico Clínico',
  componentName: 'PClinicalProfile', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillar-clinical-profile" */
        '@/pillars/clinicalProfile/PClinicalProfile.vue'
      )
  )
}

export const channel = {
  id: PILLAR_ID.CHANNEL,
  title: 'Chat',
  componentName: 'PChannel', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillars" */
        '@/pillars/channel/PChannel.vue'
      )
  )
}

export const roteiro = {
  id: PILLAR_ID.BUD,
  title: 'Roteiro',
  componentName: 'PBud', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillar-bud" */
        '@/pillars/bud/PBud.vue'
      )
  )
}

export const timeline = {
  id: PILLAR_ID.TIMELINE,
  title: 'Timeline',
  componentName: 'PTimeline', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillar-timeline" */
        '@/pillars/timeline/PTimeline.vue'
      )
  )
}

export const registro = {
  id: PILLAR_ID.CLINICAL_RECORD,
  title: 'Registro clínico',
  hidden: hiddenPillars.includes(PILLAR_ID.CLINICAL_RECORD),
  componentName: 'PClinicalRecord', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillar-registro" */
        '@/pillars/clinicalRecord/PClinicalRecord.vue'
      )
  )
}

export const wanda = {
  id: PILLAR_ID.WANDA,
  title: 'Wanda',
  componentName: 'PHealthEvents', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "wanda" */
        '@/pillars/healthEvents/PHealthEvents.vue'
      )
  )
}

export const casos = {
  id: PILLAR_ID.DEMAND,
  title: 'Lista de demandas',
  componentName: 'PDemands', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillar-demands" */
        '@/pillars/demands/PDemands.vue'
      )
  )
}

export const pda = {
  id: PILLAR_ID.HEALTH_PLAN,
  title: 'Plano de Ação',
  componentName: 'PHealthPlan', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillar-health-plan" */
        '@/pillars/healthPlan/PHealthPlan.vue'
      )
  )
}

export const exames = {
  id: PILLAR_ID.EXAMS,
  title: 'Exames',
  componentName: 'PTestResults', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillar-test-results" */
        '@/pillars/testResults/PTestResults.vue'
      )
  )
}

export const eita = {
  id: PILLAR_ID.EITA,
  title: 'Eita',
  isEmbedded: (personId: string) =>
    `${process.env.VUE_APP_EITA_URL}/member/${personId}?isEHR=1`
}

export const risco = {
  id: PILLAR_ID.RISK,
  title: 'Risco',
  componentName: 'PRisk', //important for keep-alive exclude funcionality
  component: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "pillar-risk" */
        '@/pillars/risk/PRisk.vue'
      )
  )
}
